'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require('react-redux');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = require('utils');

var _subscriptions = require('redux/modules/subscriptions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestartSubscriptionDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    plans: state.subscriptions,
    subscription: state.user.subscription,
    resuming: state.subscriptions.resuming,
    resumed: state.subscriptions.resumed,
    resumeError: state.subscriptions.resumeError
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(RestartSubscriptionDialog, _React$Component);

  function RestartSubscriptionDialog() {
    (0, _classCallCheck3.default)(this, RestartSubscriptionDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RestartSubscriptionDialog.__proto__ || (0, _getPrototypeOf2.default)(RestartSubscriptionDialog)).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(RestartSubscriptionDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _subscriptions.getSubscriptionPlans)());
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      if (this.props.reporting) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: 'onSubscribeClick',
    value: function onSubscribeClick() {
      this.props.dispatch((0, _subscriptions.resumeSubscription)());
    }
  }, {
    key: 'getCurrentPlan',
    value: function getCurrentPlan() {
      var _props = this.props,
          subscription = _props.subscription,
          plans = _props.plans;


      return _underscore2.default.find(plans.plans, function (p) {
        return p.type === subscription.planId;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var styles = require('./RestartSubscriptionDialog.scss');

      var _props2 = this.props,
          subscription = _props2.subscription,
          plans = _props2.plans,
          resuming = _props2.resuming,
          resumed = _props2.resumed;

      var planName = subscription.planName;
      var plan = this.getCurrentPlan();
      var planCost = plan && ' @ ' + (0, _utils.prettyDollars)(plan.amount) + ' / ' + (plan.billing.toLowerCase() == 'monthly' ? 'mo' : plan.billing.toLowerCase() == 'annual' ? 'yr' : '');

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.RestartSubscriptionDialog, true), (0, _defineProperty3.default)(_classnames, styles['RestartSubscriptionDialog--error'], this.state.error), _classnames));

      return _react2.default.createElement(
        _components.PopupBox,
        null,
        resuming && _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(_components.LoadingIndicator, { className: styles['CancelSubscriptionDialog__loading-indicator'] })
        ),
        !resumed && !resuming && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles['RestartSubscriptionDialog__question'] },
            'Would you like to continue your previously active subscription plan?'
          ),
          _react2.default.createElement(
            'div',
            { className: styles['RestartSubscriptionDialog__plan'] },
            _react2.default.createElement(
              'div',
              { className: styles['RestartSubscriptionDialog__plan-value'] },
              planName,
              '\xA0'
            ),
            plan && _react2.default.createElement(
              'div',
              { className: styles['RestartSubscriptionDialog__plan-value'] },
              planCost
            ),
            plans.gettingPlans && _react2.default.createElement(_components.LoadingIndicator, null)
          ),
          _react2.default.createElement(
            'div',
            { className: styles['RestartSubscriptionDialog__buttons'] },
            _react2.default.createElement(_components.Button, { secondary: true, className: styles['RestartSubscriptionDialog__button'], label: 'Change Plan', link: true, to: '/pricing', onClick: function onClick() {
                return _this2.props.onCloseNo();
              } }),
            _react2.default.createElement(_components.Button, { primary: true, className: styles['RestartSubscriptionDialog__button'], label: 'Yes, Please', onClick: this.onSubscribeClick.bind(this) })
          )
        ),
        resumed && !resuming && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles['RestartSubscriptionDialog__question-centered'] },
            'You have been subscribed.'
          ),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(_components.Button, { primary: true, label: 'Close', onClick: this.handleCancelClick.bind(this) })
          )
        )
      );
    }
  }]);
  return RestartSubscriptionDialog;
}(_react2.default.Component)) || _class);
exports.default = RestartSubscriptionDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RestartSubscriptionDialog/RestartSubscriptionDialog.jsx
// module id = 2423
// module chunks = 0